<div class="card-header">
    <span>
        <span>Existing API Keys</span>
    </span>
    <button class="btn btn-sm btn-warning float-right" (click)="generateNewApiKey(ApiKeyGenerateModal)"
        style="font-size: 14px;margin-top: -4px;background-color:  rgb(87,200,231);color: #ffffff;height:38px;">
        <span tooltip="Click here to add a new API key">
            <i class="fa fa-plus-circle" style="margin-top:6px;color:#fff;"></i> New API Key</span>
    </button>
</div>
<div class="content-body padding-top-20 padding-bottom-20">
    <div class="row">
        <p-table [value]="apiKeys" [lazy]="true" (onLazyLoad)="onPageChange($event)"
            [paginator]="apiKeys!=null && apiKeys.length>0" [rows]="10" [totalRecords]="totalRecords" #clientKeysTable
            class="table table-striped">
            <ng-template pTemplate="header">
                <tr style="height: 65px;">
                    <th class="col-lg-6" style="width:4%;text-align: center;">#
                    </th>
                    <th style="width:15%;">Account Name
                    </th>
                    <th style="width:15%;">Client Name
                    </th>
                    <th style="width:21%;">Client Id
                    </th>
                    <th style="width:35%;">Client Key
                    </th>
                    <th style="width:10%;">Status
                    </th>
                </tr>
                <tr style="font-family:Arial, FontAwesome;text-align: center;">
                    <td class="primeng-table-search">

                    </td>
                    <td class="primeng-table-search">
                        <input class="primeng-table-search-field  search-bar-true"
                            placeholder="&#xf002;  Account Name" pInputText type="text"
                            (input)="onSearch($event.target.value,'accountName')">
                    </td>
                    <td class="primeng-table-search">
                        <input class="primeng-table-search-field  search-bar-true"
                            placeholder="&#xf002;  Client Name" pInputText type="text"
                            (input)="onSearch($event.target.value,'clientName')">
                    </td>
                    <td class="primeng-table-search">

                    </td>
                    <td class="primeng-table-search">

                    </td>
                    <td class="primeng-table-search">

                    </td>
                </tr>
                <tr *ngIf="apiKeys==null || apiKeys.length==0"
                    style="border-left: 1px solid #f4f4f4;border-right: 1px solid #f4f4f4;border-bottom: 1px solid #f4f4f4;">
                    <td colspan="6">
                        <div style="padding: 5px;text-align: center;">
                            No record found
                        </div>
                    </td>
                </tr>
                <!-- <tr *ngIf="apiKeys!=null && apiKeys.length>0"
                    style="font-family:Arial, FontAwesome;text-align: center;">
                    <td class="primeng-table-search">
                    </td>
                    <td class="primeng-table-search">
                        <input class="primeng-table-search-field  search-bar-true" placeholder="&#xf002;  Account name"
                            pInputText type="text" (input)="clientKeysTable.filter($event.target.value, 'accountName', 'contains')">
                    </td>
                    <td class="primeng-table-search">
                        <input class="primeng-table-search-field  search-bar-true" placeholder="&#xf002; Client Name"
                            pInputText type="text" (input)="clientKeysTable.filter($event.target.value, 'clientName', 'contains')">
                    </td>
                    <td class="primeng-table-search">
                        <input class="primeng-table-search-field  search-bar-true" placeholder="&#xf002;  Client Id"
                            pInputText type="text" (input)="clientKeysTable.filter($event.target.value, 'clientId', 'contains')">
                    </td>
                    <td class="primeng-table-search">
                    </td>
                </tr> -->
            </ng-template>
            <ng-template pTemplate="body" let-apiKeys let-i="rowIndex">
                <tr class="table-striped" style="cursor: pointer;">
                    <td style="text-align: center;">
                        {{i+1}}
                    </td>
                    <td>{{apiKeys.accountName}}
                        <span *ngIf="apiKeys.accountCode!=null"> - {{apiKeys.accountCode}}</span>
                    </td>
                    <td>
                        <br> {{apiKeys.clientName}}
                    </td>
                    <!-- <td>{{apiKeys.clientId}}</td> -->
                    <td>
                        <div style="display:flex">
                            <input disabled type="text" [(ngModel)]="apiKeys.clientId" name="clientId" id="clientId"
                                class="form-control" style="cursor: text;" />

                            <button type="button" [disabled]="!apiKeys.clientId" title="Copy Client Key"
                                class="btn btn-warning btn-raised" (click)="copyClientKey(apiKeys.clientId, 'id')"
                                style="margin-left:20px">
                                <i class="fa fa-clone" aria-hidden="true"></i>
                            </button>
                        </div>
                    </td>
                    <!-- <td>{{apiKeys.clientSecret}}</td> -->
                    <td>
                        <div style="display:flex">
                            <input disabled type="text" [(ngModel)]="apiKeys.clientSecret" name="clientSecret"
                                id="clientSecret" class="form-control" style="cursor: text;" />

                            <button type="button" [disabled]="!apiKeys.clientSecret" title="Copy Client Key"
                                class="btn btn-warning btn-raised"
                                (click)="copyClientKey(apiKeys.clientSecret, 'secret')" style="margin-left:20px">
                                <i class="fa fa-clone" aria-hidden="true"></i>
                            </button>
                        </div>
                    </td>
                    <td>
                        <div style="text-align: center;">
                            <p-inputSwitch [(ngModel)]="apiKeys.status" (onChange)="setKeyStatus(apiKeys)">
                            </p-inputSwitch>
                        </div>
                    </td>
                </tr>
            </ng-template>
        </p-table>
    </div>
</div>


<ng-template #ApiKeyGenerateModal let-modal>
    <div>
        <div class="modal-content">
            <div class="modal-header">
                <h4 id="dialog-events-name" class="modal-title pull-left">Generate New API Key</h4>
                <button type="button" class="close pull-right" aria-label="Close" (click)="modalRef.hide()">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body" style="min-height: 125px; padding-top: 20px !important;">
                <div class="col-lg-6">
                    <label>Select Account*:</label>
                    <ng-select [items]="accounts" name="accounts" bindLabel="accountName" [(ngModel)]="accountId"
                        [clearable]="true" [searchable]="true" bindValue="accountId" placeholder="Select account">
                    </ng-select>
                </div>
                <div class="col-lg-6">
                    <label>API Key Name*:</label>
                    <input type="text" [(ngModel)]="clientName" #firstName="ngModel" name="firstName"
                        pattern="^[a-zA-Z ]*" id="firstName" class="form-control"
                        placeholder="Enter API Key name here..." required />
                </div>
            </div>
            <div class="modal-footer d-flex flex-column flex-md-row justify-content-md-between align-items-center">
                <div class="d-flex flex-column flex-md-row align-items-md-center">
                    <button class="btn btn-sm btn-primary" style="margin-right: 5px;" (click)="onGenerateClick()">
                        <i class="fa fa-credit-card" style="margin-right: 5px;"></i>
                        Generate
                    </button>
                    <button class="btn btn-sm btn-danger ml-md-2 mt-md-0" style="background-color:#A1630D;"
                        (click)="modalRef.hide()">
                        Cancel
                    </button>
                </div>
            </div>
        </div>
    </div>
</ng-template>